import { useContext, useEffect, useRef, useCallback } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";
import UploadResume from "../Components/Resume-Upload/ResumeUpload";
import AiDriven from "../Components/AI-Driven-Screening/AiDrivenScreening";
import ManageAccount from "../Components/Manage-Account/ManageAccount";
import styled from "@emotion/styled";
import { DynamicContext } from "../Context/DynamicContext";
import { ToastContainer } from "react-toastify";
import CandidateTableList from "../Components/Applicant-Tracking/Candidates/CandidateTableList";
import JobsTableList from "../Components/Applicant-Tracking/Jobs/JobsTableList";
import InterviewSchdule from "../Components/Applicant-Tracking/Interview-Schdule/InterviewSchedule";
import LoginPage from "../Components/Login/Login";
import Onboarding from "../Components/Login/Onboarding";
import ForgotPassword from "../Components/Login/ForgotPassword";
import ResetPassword from "../Components/Login/ResetPassword";
import SelectPlan from "../Components/Subcription-Trial-Pages/SelectPlan";
import Signup from "../Components/Signup/SignupType";
import AdminSignup from "../Components/Signup/MainSignupPage";
import MemberSignup from "../Components/Signup/MemberSignup";
import AuthRoute from "./AuthRoute";
import PrivateRoute from "./PrivateRoute";
import ErrorPage from "../Components/Error-Page/ErrorPage";
import CreateClient from "../Components/Applicant-Tracking/Clients/Create-Client/CreateClient";
import Vendors from "../Components/Applicant-Tracking/Vendors/Vendors";
import Settings from "../Components/Settings-Pages/Settings";
import {
  ScrollToTop,
  handleLogoutCommon,
} from "../Common/Common-Function/CommonFunctions";
import Dashboard from "../Components/Dashboard/DashboardWithChat";
import SessionExpiredToast from "../Components/SessionExpiredToast";
import { AuthProvider } from "../Context/AuthContext";
import Dice from "../Components/Dice/DiceSearch";
import Conversations from "../Components/Conversations/Conversations";
import Feedback from "../Components/FeedBack/FeedBack";
import VybogTALLoaderAnimation from "../Common/Dynamic-Animations/DynamicAnimations";
import { post } from "../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  USERS_UPDATE,
  SEND_USER_ACTIVE_TRACK,
} from "../helper/url_helper";
import MonsterUsaSearch from "../Components/Monster/Monster-USA/MonsterUsaSearch";
import MonsterSearch from "../Components/Monster/MonsterSearch";
import UserJoinPage from "../Components/User-Join-Page/UserJoinPage";
import IrmtSearch from "../Components/Irmt-Candidates/IrmtSearch";
import {
  emailAccessByRoute,
  emailRestrictionFallbackPath,
  sideMenuHiddenRoutes,
} from "./emailAccess";
import SharedJobView from "../Components/Careers/SharedJobView";
import UserRecentTrack from "../Components/Dashboard/UserDashboard/UserRecentTrack";
import SubscriptionFetcher from "../Context/SubscriptionFetcher";
import envConfig from "../helper/env_config";
import moment from "moment-timezone";
import { put } from "../helper/Api_helper";
import PublicBoardJobs from "../Components/Public-Job-Board/PublicBoardJobs";
import Notifications from "../Components/Notifications/Notifications";
import MemberDashboard from "../Components/Dashboard/Member-Dashboard/MemberDashboard";
import AdminDashboard from "../Components/Dashboard/Admin-Dashboard/AdminDashboard";
import DailyReport from "../Components/Daily-Report/DailyReport";
import InvoiceList from "../Components/Invoice-Tracking/InvoiceList";
import SuperAdminDashboard from "../Components/Dashboard/Super-Admin-Dashboard/SuperAdminDashboard";
import NotificationSocketManager from "../Common/Notification-Socket/NotificationSocketManager";

const PartionContainer = styled("div")({
  display: "flex",
  height: "100vh",
  overflowX: "hidden",
  justifyContent: "space-between",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "@media (max-width: 768px)": {
    flexDirection: "column",
  },
});

const SideNavbarContainer = styled("div")(({ closeTab }) => ({
  width: closeTab ? "70px" : "250px",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  transition: "width 0.3s ease",
  flexShrink: 0,
  "@media (max-width: 1200px)": {
    width: closeTab ? "70px" : "200px",
  },
  "@media (max-width: 1024px)": {
    width: closeTab ? "70px" : "200px",
  },
  "@media (max-width: 768px)": {
    height: "auto",
  },
}));

const PagesContainer = styled("div")(({ closeTab }) => ({
  height: "100vh",
  overflow: "auto",
  overflowX: "hidden",
  transition: "width 0.3s ease",
  flex: "1",
  "@media (max-width: 768px)": {
    marginTop: "8vh",
  },
  "@media (max-width: 480px)": {
    overflow: "visible",
  },
}));

const PrivateLayout = () => {
  const location = useLocation();
  const isSettingsPage = location.pathname.includes("/settings");
  const {
    closeTab,
    userDetails,
    isSubscriptionLoading,
    isInitialSubscriptionFetchDone,
  } = useContext(DynamicContext);

  const matchAllowedEmailsForPath = (pathname) => {
    const pathOnly = pathname.split("?")[0];
    for (const pattern of Object.keys(emailAccessByRoute || {})) {
      if (!pattern) continue;
      if (pattern.endsWith("*")) {
        const base = pattern.slice(0, -1);
        if (pathOnly.startsWith(base)) {
          return emailAccessByRoute[pattern];
        }
      } else if (pathOnly === pattern) {
        return emailAccessByRoute[pattern];
      }
    }
    return undefined;
  };

  const allowedEmails = matchAllowedEmailsForPath(location.pathname);
  if (Array.isArray(allowedEmails) && allowedEmails.length > 0) {
    const userEmail = (userDetails?.email || "").toLowerCase();
    const isAllowed = allowedEmails
      .map((e) => (e || "").toLowerCase())
      .includes(userEmail);
    if (!isAllowed) {
      return (
        <Navigate to={emailRestrictionFallbackPath || "/dashboard"} replace />
      );
    }
  }

  const shouldHideSideMenu = (() => {
    const pathOnly = location.pathname.split("?")[0];
    for (const pattern of sideMenuHiddenRoutes || []) {
      if (!pattern) continue;
      if (pattern.endsWith("*")) {
        const base = pattern.slice(0, -1);
        if (pathOnly.startsWith(base)) return true;
      } else if (pathOnly === pattern) {
        return true;
      }
    }
    return false;
  })();

  if (isSubscriptionLoading || !isInitialSubscriptionFetchDone) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <VybogTALLoaderAnimation />
      </div>
    );
  }

  return (
    <>
      <NotificationSocketManager />
      {isSettingsPage || shouldHideSideMenu ? (
        <div
          className="pages-container"
          style={{
            width: "100%",
            height: "100vh",
          }}
        >
          <Outlet />
        </div>
      ) : (
        <PartionContainer className="partition-container">
          <SideNavbarContainer closeTab={closeTab}>
            <Navbar />
            <Feedback />
          </SideNavbarContainer>
          <PagesContainer closeTab={closeTab}>
            <Outlet />
          </PagesContainer>
        </PartionContainer>
      )}
    </>
  );
};

const DashboardRedirect = () => {
  const {
    isSubscriptionLoading,
    isInitialSubscriptionFetchDone,
    AdminAccess,
    MemberAccess,
    SuperAdminAccess,
    hasSubscription,
  } = useContext(DynamicContext);
  if (isSubscriptionLoading || !isInitialSubscriptionFetchDone) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <VybogTALLoaderAnimation />
      </div>
    );
  }

  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (SuperAdminAccess) {
    return <SuperAdminDashboard />;
  }
  if (!hasSubscription) {
    return <Dashboard />;
  }
  const shouldShowUserDashboard =
    AdminAccess || MemberAccess || hasSubscription;

  return shouldShowUserDashboard ? (
    AdminAccess ? (
      <AdminDashboard />
    ) : (
      <MemberDashboard />
    )
  ) : (
    <Dashboard />
  );
};

const RestrictedRoute = ({ element, path }) => {
  const {
    userDetails,
    hasSubscription,
    isSubscriptionLoading,
    isInitialSubscriptionFetchDone,
    isVendorFeatureEnabled,
    isVendorIntegrationsEnabled,
    UnAssociatedAccess,
    AdminAccess,
    MemberAccess,
  } = useContext(DynamicContext);
  const isSuperAdmin = userDetails?.tenant_id === envConfig.superAdminTenantId;

  const unSubscribeAdminAllowedRoutes = [
    "/dashboard",
    "/settings",
    "/settings/subscriptions",
    "/settings/profile",
    "/settings/appearance",
  ];

  const unSubscribeMemberAllowedRoutes = [
    "/dashboard",
    "/settings",
    "/settings/profile",
    "/settings/appearance",
  ];

  const unassociatedAllowedRoutes = [
    "/dashboard",
    "/settings",
    "/settings/profile",
    "/settings/appearance",
  ];

  if (isSubscriptionLoading || !isInitialSubscriptionFetchDone) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <VybogTALLoaderAnimation />
      </div>
    );
  }

  // Restrict routes for UNASSOCIATED users
  if (UnAssociatedAccess && !unassociatedAllowedRoutes.includes(path)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Restrict routes for users without subscription based on role
  if (!isSuperAdmin && !hasSubscription) {
    if (AdminAccess && !unSubscribeAdminAllowedRoutes.includes(path)) {
      return <Navigate to="/dashboard" replace />;
    }
    if (MemberAccess && !unSubscribeMemberAllowedRoutes.includes(path)) {
      return <Navigate to="/dashboard" replace />;
    }
    if (!userDetails?.role && !unassociatedAllowedRoutes.includes(path)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Restrict /vendors route if vendor feature is not enabled
  if (path === "/vendors" && !isVendorFeatureEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  // Restrict /vendors integration route if vendor integration feature is not enabled
  if (path === "/dice-search" && !isVendorIntegrationsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path === "/monster-search-ind" && !isVendorIntegrationsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path === "/monster-search-usa" && !isVendorIntegrationsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path === "/irmt-search" && !isVendorIntegrationsEnabled) {
    return <Navigate to="/dashboard" replace />;
  }
  // Only allow clients tab for ADMIN and MANAGER roles
  if (path === "/clients-list") {
    const userRole = userDetails?.role;
    if (!["ADMIN", "MANAGER", "SYSTEM_ADMIN"].includes(userRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return element;
};

const ProtectedUserJoinRoute = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  if (!id) {
    return <Navigate to="/login" replace />;
  }

  return <UserJoinPage />;
};

const ProtectedSharedJobRoute = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  if (!id) {
    return <Navigate to="/" replace />;
  }

  return <SharedJobView />;
};

function AppRouter() {
  const token = localStorage.getItem("token");
  const heartbeatTimerRef = useRef(null);
  const idleTimerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());
  const isIdleRef = useRef(false);
  const isTabVisibleRef = useRef(true);
  const isHeartbeatRunningRef = useRef(false);

  const { userDetails, setUserDetails } = useContext(DynamicContext);
  const DEFAULT_HEARTBEAT_SECONDS = 300;
  const IDLE_TIMEOUT_SECONDS = 60;

  const clearAllTimers = useCallback(() => {
    if (heartbeatTimerRef.current) {
      clearTimeout(heartbeatTimerRef.current);
      heartbeatTimerRef.current = null;
    }
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
      idleTimerRef.current = null;
    }
    isHeartbeatRunningRef.current = false;
  }, []);

  const clearHeartbeatTimer = useCallback(() => {
    if (heartbeatTimerRef.current) {
      clearTimeout(heartbeatTimerRef.current);
      heartbeatTimerRef.current = null;
    }
    isHeartbeatRunningRef.current = false;
  }, []);

  const resetIdleTimer = useCallback(() => {
    lastActivityRef.current = Date.now();
    isIdleRef.current = false;
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
      idleTimerRef.current = null;
    }
    idleTimerRef.current = setTimeout(() => {
      isIdleRef.current = true;
      if (isHeartbeatRunningRef.current) {
        clearHeartbeatTimer();
        isHeartbeatRunningRef.current = false;
      }
    }, IDLE_TIMEOUT_SECONDS * 1000);
  }, [clearHeartbeatTimer]);

  const sendUserHeartbeat = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (
      !token ||
      document.hidden ||
      isIdleRef.current ||
      !userDetails?.tenant_id
    ) {
      if (isHeartbeatRunningRef.current) {
        clearHeartbeatTimer();
        isHeartbeatRunningRef.current = false;
      }
      return;
    }
    try {
      const res = await post(VYLABS_BASE_URL, SEND_USER_ACTIVE_TRACK);
      if (
        !document.hidden &&
        !isIdleRef.current &&
        token &&
        userDetails?.tenant_id
      ) {
        const intervalSeconds =
          res?.heartbeat_interval_seconds || DEFAULT_HEARTBEAT_SECONDS;
        heartbeatTimerRef.current = setTimeout(
          sendUserHeartbeat,
          intervalSeconds * 1000,
        );
        isHeartbeatRunningRef.current = true;
      } else {
        isHeartbeatRunningRef.current = false;
      }
    } catch (error) {
      console.log("send User Heartbeat error", error);
      if (
        !document.hidden &&
        !isIdleRef.current &&
        token &&
        userDetails?.tenant_id
      ) {
        heartbeatTimerRef.current = setTimeout(
          sendUserHeartbeat,
          DEFAULT_HEARTBEAT_SECONDS * 1000,
        );
        isHeartbeatRunningRef.current = true;
      } else {
        isHeartbeatRunningRef.current = false;
      }
    }
  }, [userDetails?.tenant_id, clearHeartbeatTimer]);

  const startHeartbeatIfNeeded = useCallback(() => {
    const token = localStorage.getItem("token");
    if (
      !token ||
      document.hidden ||
      isIdleRef.current ||
      !userDetails?.tenant_id ||
      isHeartbeatRunningRef.current
    ) {
      return;
    }
    clearHeartbeatTimer();
    sendUserHeartbeat();
  }, [userDetails?.tenant_id, clearHeartbeatTimer, sendUserHeartbeat]);

  const handleVisibilityChange = useCallback(() => {
    isTabVisibleRef.current = !document.hidden;

    if (document.hidden) {
      clearHeartbeatTimer();
      isHeartbeatRunningRef.current = false;
    } else {
      resetIdleTimer();
      startHeartbeatIfNeeded();
    }
  }, [clearHeartbeatTimer, resetIdleTimer, startHeartbeatIfNeeded]);

  const handleUserActivity = useCallback(() => {
    if (document.hidden) return;
    resetIdleTimer();
    if (
      !isHeartbeatRunningRef.current &&
      !isIdleRef.current &&
      userDetails?.tenant_id
    ) {
      startHeartbeatIfNeeded();
    }
  }, [resetIdleTimer, startHeartbeatIfNeeded, userDetails?.tenant_id]);

  useEffect(() => {
    const activityEvents = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "input",
    ];
    const wrappedHandler = (event) => {
      if (event.type === "mousemove") {
        if (
          lastActivityRef.current &&
          Date.now() - lastActivityRef.current < 2000
        ) {
          return;
        }
      }
      handleUserActivity();
    };

    activityEvents.forEach((event) => {
      document.addEventListener(event, wrappedHandler, { passive: true });
    });

    return () => {
      activityEvents.forEach((event) => {
        document.removeEventListener(event, wrappedHandler);
      });
    };
  }, [handleUserActivity]);

  useEffect(() => {
    const checkTokenExpiry = () => {
      const currentToken = localStorage.getItem("token");
      if (!currentToken) return;
      const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
      };
      const refreshToken = getCookie("refreshToken");
      if (!refreshToken) {
        handleLogoutCommon();
        return;
      }
      const expiry = getCookie("refreshTokenExpiry");
      if (expiry) {
        const currentTime = new Date().getTime();
        const expiryTime = new Date(expiry).getTime();
        const logoutTime = expiryTime - 60 * 1000;
        if (currentTime > logoutTime) {
          handleLogoutCommon();
        }
      }
    };
    checkTokenExpiry();
    const interval = setInterval(checkTokenExpiry, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateUserTimezoneFromUTC = async () => {
      if (!userDetails || userDetails?.timezone !== "UTC") {
        return;
      }
      try {
        const systemTimezone = moment.tz.guess();
        if (systemTimezone && systemTimezone !== "UTC") {
          await put(VYLABS_BASE_URL, USERS_UPDATE, {
            timezone: systemTimezone,
          });
          setUserDetails((prev) => ({
            ...prev,
            timezone: systemTimezone,
          }));
        }
      } catch (error) {
        console.error("Failed to update timezone:", error);
      }
    };
    if (token && userDetails) {
      updateUserTimezoneFromUTC();
    }
  }, [userDetails, setUserDetails, token]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token && userDetails?.tenant_id && !document.hidden) {
      resetIdleTimer();
      sendUserHeartbeat();
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearAllTimers();
    };
  }, [
    userDetails?.tenant_id,
    resetIdleTimer,
    sendUserHeartbeat,
    handleVisibilityChange,
    clearAllTimers,
  ]);

  useEffect(() => {
    if (userDetails?.tenant_id) {
      const token = localStorage.getItem("token");
      if (token && !document.hidden) {
        isIdleRef.current = false;
        resetIdleTimer();
        sendUserHeartbeat();
      }
    } else {
      clearAllTimers();
      isIdleRef.current = true;
    }
  }, [
    userDetails?.tenant_id,
    resetIdleTimer,
    sendUserHeartbeat,
    clearAllTimers,
  ]);

  return (
    <>
      <BrowserRouter future={{ v7_startTransition: true }}>
        <AuthProvider>
          <SubscriptionFetcher />
          <SessionExpiredToast />
          <ScrollToTop />
          <ToastContainer />
          <Routes>
            <Route element={<AuthRoute />}>
              <Route path="/" element={<Onboarding />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/admin-signup" element={<AdminSignup />} />
              <Route path="/member-signup" element={<MemberSignup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/select-plan" element={<SelectPlan />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Route>
            <Route path="/join" element={<ProtectedUserJoinRoute />} />
            <Route path="/careers" element={<ProtectedSharedJobRoute />} />
            <Route path="/board/:slug/jobs" element={<PublicBoardJobs />} />
            <Route element={<PrivateRoute />}>
              <Route element={<PrivateLayout />}>
                <Route
                  path="/dashboard"
                  element={
                    <RestrictedRoute
                      element={<DashboardRedirect />}
                      path="/dashboard"
                    />
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <RestrictedRoute element={<Settings />} path="/settings" />
                  }
                />
                <Route
                  path="/settings/subscriptions"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/subscriptions"
                    />
                  }
                />
                <Route
                  path="/settings/customizations"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/customizations"
                    />
                  }
                />
                <Route
                  path="/settings/invoice-configuration"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/invoice-confiuration"
                    />
                  }
                />
                <Route
                  path="/settings/profile"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/profile"
                    />
                  }
                />
                <Route
                  path="/settings/users"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/users"
                    />
                  }
                />
                <Route
                  path="/settings/career-portal"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/career-portal"
                    />
                  }
                />
                <Route
                  path="/settings/appearance"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/appearance"
                    />
                  }
                />
                <Route
                  path="/settings/feedback-list"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/feedback-list"
                    />
                  }
                />
                <Route
                  path="/settings/portal-integration"
                  element={
                    <RestrictedRoute
                      element={<Settings />}
                      path="/settings/portal-integration"
                    />
                  }
                />
                <Route
                  path="/daily-reports"
                  element={
                    <RestrictedRoute
                      element={<DailyReport />}
                      path="/daily-reports"
                    />
                  }
                />
                <Route
                  path="/user-recent-tracks"
                  element={
                    <RestrictedRoute
                      element={<UserRecentTrack />}
                      path="/user-recent-tracks"
                    />
                  }
                />
                <Route
                  path="/resume-parser"
                  element={
                    <RestrictedRoute
                      element={<UploadResume />}
                      path="/resume-parser"
                    />
                  }
                />
                <Route
                  path="/invoice-list"
                  element={
                    <RestrictedRoute
                      element={<InvoiceList />}
                      path="/invoice-list"
                    />
                  }
                />
                <Route
                  path="/conversation/:id?"
                  element={
                    <RestrictedRoute
                      element={<AiDriven />}
                      path="/conversation/:id?"
                    />
                  }
                />
                <Route
                  path="/manage-account"
                  element={
                    <RestrictedRoute
                      element={<ManageAccount />}
                      path="/manage-account"
                    />
                  }
                />
                <Route
                  path="/candidates-list"
                  element={
                    <RestrictedRoute
                      element={<CandidateTableList />}
                      path="/candidates-list"
                    />
                  }
                />
                <Route
                  path="/clients-list"
                  element={
                    <RestrictedRoute
                      element={<CreateClient />}
                      path="/clients-list"
                    />
                  }
                />
                <Route
                  path="/vendors"
                  element={
                    <RestrictedRoute element={<Vendors />} path="/vendors" />
                  }
                />
                <Route
                  path="/jobs-list"
                  element={
                    <RestrictedRoute
                      element={<JobsTableList />}
                      path="/jobs-list"
                    />
                  }
                />
                <Route
                  path="/interview-schdule"
                  element={
                    <RestrictedRoute
                      element={<InterviewSchdule />}
                      path="/interview-schdule"
                    />
                  }
                />
                <Route
                  path="/dice-search"
                  element={
                    <RestrictedRoute element={<Dice />} path="/dice-search" />
                  }
                />
                <Route
                  path="/irmt-search"
                  element={
                    <RestrictedRoute
                      element={<IrmtSearch />}
                      path="/irmt-search"
                    />
                  }
                />
                <Route
                  path="/conversations"
                  element={
                    <RestrictedRoute
                      element={<Conversations />}
                      path="/conversations"
                    />
                  }
                />
                <Route
                  path="/monster-search-ind"
                  element={
                    <RestrictedRoute
                      element={<MonsterSearch />}
                      path="/monster-search-ind"
                    />
                  }
                />
                <Route
                  path="/monster-search-usa"
                  element={
                    <RestrictedRoute
                      element={<MonsterUsaSearch />}
                      path="/monster-search-usa"
                    />
                  }
                />
                <Route
                  path="/notifications"
                  element={
                    <RestrictedRoute
                      element={<Notifications />}
                      path="/notifications"
                    />
                  }
                />
              </Route>
            </Route>
            <Route
              path="*"
              element={token ? <ErrorPage /> : <Navigate to="/login" replace />}
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default AppRouter;
